import React from 'react';
import { ReferralProvider } from '@/context/referral.context';

const withReferral = ({ project, children, hideReferralCart = false }) => {
  return (
    <ReferralProvider project={project} hideReferralCart={hideReferralCart}>
      {children}
    </ReferralProvider>
  );
};

export default withReferral;
